import React from "react";
import parse from "html-react-parser";
import {clsx} from "clsx";

const TableHead = ({showLegend, headList, showSpecials, showOrderButton}) => {
    let col_count = showSpecials ? 2 : 1;
    col_count += showOrderButton ? 1 : 0;

    return (
        <thead>
        <tr key={'product_details_head_tr'}>
            {
                Object.values(headList).map((headItems, index) => {
                    const key = `product_details_head_tr_th_${index}`
                    const headItemsIndexes = Object.keys(headItems);
                    const title = headItems['title'] ? parse(headItems['title']) : '';

                    if(title === 'Bestellen' && showSpecials && !showOrderButton) {
                        return null;
                    }
                    if (showSpecials ||
                        !['only_for_users'].includes(headItems['action'])
                    ) {
                        const classTh = clsx(headItems['col'] === 'Bestellen' ? 'print-hide' : '', index === 0 ? 'sticky-head-col' : '');

                        return (
                            <th scope="col" key={key}
                                width={headItemsIndexes.includes('width') ? headItems['width'] : ''}
                                colSpan={headItemsIndexes.includes('col') ? headItems['col'] : '1'}
                                className={classTh}
                            >
                                {title}
                            </th>
                        );
                    }
                    return null;

                })
            }
            {(showLegend && col_count > 0) &&
                <th scope="col" colSpan={col_count} key={'product_details_head_tr_th_legend'}/>
            }
        </tr>
        </thead>
    )
}

export default TableHead;
